/**
 * The availability seam's face — [BUT-843, ours].
 *
 * Rendered by both the bay region (step 11) and the slot region (step 12)
 * whenever `lessonAvailabilitySource.ts` answers `unavailable`. An
 * informational state, not an error the member caused — the flow itself is
 * fine, the two questions it asks just have no answer yet
 * (`instructors PLAN.md L2`).
 *
 * `data-reason` puts the literal reason string in the DOM too, so
 * `lesson-flow-availability-endpoint-pending` is greppable from a rendered
 * page as well as from source.
 *
 * @module pages/lessons/components/LessonAvailabilityPending
 */

import type { ReactNode } from 'react';
import { CardsErrorIcon } from '@butter/ui/icons';
import { EmptyState } from '@butter/ui/components/feedback';

export interface LessonAvailabilityPendingProps {
  title: string;
  description: string;
  reason: string;
  action?: ReactNode;
  className?: string;
}

export function LessonAvailabilityPending({
  title,
  description,
  reason,
  action,
  className,
}: LessonAvailabilityPendingProps) {
  return (
    <div
      className={`rounded-3xl bg-bg-secondary${className ? ` ${className}` : ''}`}
      role="status"
      data-reason={reason}
      data-testid="lesson-availability-pending"
    >
      <EmptyState
        variant="muted"
        icon={<CardsErrorIcon className="size-7 text-fg-muted" />}
        title={title}
        description={description}
        action={action}
      />
    </div>
  );
}
